import { Button, Flex } from 'antd'
import { useAppDispatch, useAppSelector } from '../../utils/redux/store'
import { logout } from '../../utils/redux/authSlice'
import MainContentLayout from '../../components/MainContentLayout'

export default function Settings() {
  const dispatch = useAppDispatch()
  return (
    <MainContentLayout header={<>User Name</>}>
      <Button
        onClick={() => {
          dispatch(logout())
        }}
      >
        Logout
      </Button>
    </MainContentLayout>
  )
}
